import ItemCategory from "../Models/ViewModels/ItemCategory";
import PageModel from "../Models/ViewModels/PageModel";
import MakeRequest from "../Utilities/MakeRequest";

export function fetchItemsList(searchValue: string, sortValue: string, sortAscending: boolean, currentPage: number, pageSize: number): Promise<PageModel<ItemCategory>> {
	return new Promise<PageModel<ItemCategory>>((resolve, reject) => {
		new MakeRequest(`/api/Items/search?searchValue=${searchValue}&SortValue=${sortValue}&SortAscending=${sortAscending}&Page=${currentPage}&Size=${pageSize}`)
			.send()
			.then((response: string) => {
				resolve(JSON.parse(response));
			}, reject);
	});
}

export function fetchCreateItemModal(): Promise<string> {
	return new Promise<string>((resolve, reject) => {
		new MakeRequest('/DomainAdmin/Items/Create')
			.send()
			.then(resolve, reject);
	});
}

export function createItem(itemFormData: FormData): Promise<number> {
	return new Promise<number>((resolve, reject) => {
		new MakeRequest(`/api/Items/Create`, "Post")
			.send(itemFormData)
			.then(resolve, reject);
	});
}

export function fetchDisplayOrderModal(): Promise<string> {
	return new Promise<string>((resolve, reject) => {
		new MakeRequest('/DomainAdmin/Items/DisplayOrder')
			.send()
			.then(resolve, reject);
	});
}

export function fetchUpdateItemModal(itemId: string): Promise<string> {
	return new Promise<string>((resolve, reject) => {
		new MakeRequest(`/DomainAdmin/Items/update?id=${itemId}`)
			.send()
			.then(resolve, reject);
	});
}

export function updateItem(itemFormData: FormData, updateImage: boolean): Promise<void> {
	return new Promise<void>((resolve, reject) => {
		new MakeRequest(`/api/Items/Update?updateImage=${updateImage}`, "Put")
			.send(itemFormData)
			.then(resolve, reject);
	});
}

export function updateItemDisplayOrder(itemId: string, displayOrder: number): Promise<void> {
	return new Promise<void>((resolve, reject) => {
		const headers = {};
		headers["Content-type"] = "application/json";
		new MakeRequest(`/api/Items/UpdateDisplayOrder?itemId=${itemId}&displayOrder=${displayOrder}`, "Put", headers)
			.send()
			.then(resolve, reject);
	});
}

export function fetchDeleteItemModal(itemId: string): Promise<string> {
	return new Promise<string>((resolve, reject) => {
		new MakeRequest(`/DomainAdmin/Items/delete?id=${itemId}`)
			.send()
			.then(resolve, reject);
	});
}

export function deleteItem(itemId: string, comboItemsIds: Array<string>): Promise<void> {
	return new Promise<void>((resolve, reject) => {
		const headers = {};
		headers["Content-type"] = "application/json";
		const ids: string = comboItemsIds.join('&comboItemsIds=');
		const comboIds = ids ? `&comboItemsIds=${ids}` : "";
		new MakeRequest(`/api/Items/Delete?id=${itemId}${comboIds}`, "delete", headers)
			.send()
			.then(resolve, reject);
	});
}

export function fetchServicesDisplayOrderModal(itemId: string): Promise<string> {
	return new Promise<string>((resolve, reject) => {
		new MakeRequest(`/DomainAdmin/Items/ServicesDisplayOrder?id=${itemId}`)
			.send()
			.then(resolve, reject);
	});
}
